module.exports = __webpack_public_path__ + "static/structure-3d-tour-eiffel-4dca195910f2d61172d5376485ec097b.png";